import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  onSnapshot,
  orderBy,
  query,
  Timestamp,
  where,
} from "firebase/firestore";
import { auth, db } from "../../firebase";
import Menu from "../../panel/Menu";
import moment from "moment";
import "../../App.css";

function Viewadvance() {
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
  });

  const [bookings, setBookings] = useState([]);
  const [allBookings, setAllBookings] = useState([]);
  const [username, setUsername] = useState("");
  const [userData, setUserData] = useState(null);
  const [searchText, setSearchText] = useState("");

  /* ================= AUTH ================= */
  useEffect(() => {
    const unsub = auth.onAuthStateChanged(async (user) => {
      if (user) {
        setUserData(user);
        const snap = await getDoc(doc(db, "users", user.uid));
        if (snap.exists()) setUsername(snap.data().username);
      }
    });
    return () => unsub();
  }, []);

  /* ================= FETCH BOOKINGS ================= */
  useEffect(() => {
    const q = query(
      collection(db, "advancebookings"),
      where("status", "==", "Paid"),
      where("checkindate", ">=", moment().format("YYYY-MM-DD")),
      orderBy("checkindate", "asc")
    );

    const unsub = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((d) => ({
        id: d.id,
        data: d.data(),
      }));
      setBookings(data);
      setAllBookings(data);
    });

    return () => unsub();
  }, []);

  /* ================= SEARCH ================= */
  useEffect(() => {
    if (!searchText) {
      setBookings(allBookings);
    } else {
      setBookings(
        allBookings.filter((b) =>
          b.data.customers.custname
            .toLowerCase()
            .includes(searchText.toLowerCase())
        )
      );
    }
  }, [searchText, allBookings]);

  /* ================= DELETE ================= */
  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This booking will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it",
    });

    if (confirm.isConfirmed) {
      await deleteDoc(doc(db, "advancebookings", id));
      Toast.fire({ icon: "success", title: "Booking Deleted Successfully" });
    }
  };

  return (
    <div>
      <Menu />

      <div className="content-wrapper bg-white">
        <section className="content pt-3">
          <div className="container-fluid">

            {/* HEADER */}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h4 className="text-primary font-weight-bold">
                 Advance Bookings
              </h4>

              <input
                type="search"
                className="form-control w-25"
                placeholder="🔍 Search customer..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>

            {/* TABLE CARD */}
            <div className="card shadow-sm border-0">
              <div className="card-body table-responsive p-0">
                <table className="table table-hover table-striped mb-0">
                  <thead className="thead-light">
                    <tr>
                      <th>#</th>
                      <th>Customer</th>
                      <th>Mobile</th>
                      <th>Check-in</th>
                      <th>Check-out</th>
                      <th>Rooms</th>
                      <th>Adults</th>
                      <th className="text-right">Total</th>
                      <th className="text-right">Advance</th>
                      <th className="text-right">Balance</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {bookings.length === 0 && (
                      <tr>
                        <td colSpan="11" className="text-center text-muted py-4">
                          No advance bookings found
                        </td>
                      </tr>
                    )}

                    {bookings.map((item, index) => (
                      <tr key={item.id} className="align-middle">
                        <td>{index + 1}</td>

                        <td className="font-weight-bold text-capitalize">
                          {item.data.customers.custname}
                        </td>

                        <td>{item.data.customers.mobile}</td>

                        <td>
                          {moment(item.data.checkindate).format("DD MMM YYYY")}
                        </td>

                        <td>
                          {moment(item.data.checkoutdate).format("DD MMM YYYY")}
                        </td>

                        <td>
                          {item.data.rooms.map((r, i) => (
                            <span
                              key={i}
                              className="badge badge-info mr-1"
                            >
                              {r.roomname}
                            </span>
                          ))}
                        </td>

                        <td>
                          <span className="badge badge-secondary">
                            {item.data.adults} Adults
                          </span>
                        </td>

                        <td className="text-right font-weight-bold">
                          ₹{item.data.totalamount.toFixed(2)}
                        </td>

                        <td className="text-right text-success font-weight-bold">
                          ₹{item.data.advance.toFixed(2)}
                        </td>

                        <td className="text-right text-danger font-weight-bold">
                          ₹{item.data.remaining.toFixed(2)}
                        </td>

                        <td className="text-center">
                          <a
                            href={`view-futuredetails/${item.id}`}
                            className="btn btn-sm btn-outline-info mr-1"
                            title="View"
                          >
                            <i className="fa fa-eye"></i>
                          </a>

                          <a
                            href={`/print-advance/${item.id}`}
                            className="btn btn-sm btn-outline-primary mr-1"
                            title="Print"
                          >
                            <i className="fa fa-print"></i>
                          </a>

                          {/* Optional delete */}
                          {/* 
                          <button
                            onClick={() => handleDelete(item.id)}
                            className="btn btn-sm btn-outline-danger"
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                          */}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </section>
      </div>
    </div>
  );
}

export default Viewadvance;
